import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home           from './pages/Home';
import Success        from './pages/Success';
import Cancel         from './pages/Cancel';
import AdminLogin     from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import DonorProfile   from './pages/DonorProfile';
import ErrorBoundary  from './components/ErrorBoundary';

export default function App() {
  return (
    <ErrorBoundary>
    <BrowserRouter>
      <Routes>
        <Route path="/"             element={<Home />} />
        <Route path="/success"      element={<Success />} />
        <Route path="/cancel"       element={<Cancel />} />
        <Route path="/admin"        element={<AdminLogin />} />
        <Route path="/admin/dashboard"       element={<AdminDashboard />} />
        <Route path="/my-donations/:token"    element={<DonorProfile />} />
      </Routes>
    </BrowserRouter>
    </ErrorBoundary>
  );
}
